<template>
  <div class="row">
    <div class="col-12 offers-grid-header">
      <h3 class="all-offers-title">{{ title }}</h3>
      <p class="all-offers-counter">
        {{ translate('offDealsSliderTotalDeals', totalOffers, totalOffers) }}
      </p>
    </div>
    <div class="col-12">
      <div class="cards-grid">
        <OfferCard
          v-for="(card, idx) in offers"
          :key="`${card.cmsId}-${idx}`"
          :content="card"
          :isCompact="isCompactCardsView"
          :withDescription="!isMobile"
        />
      </div>
    </div>
    <div class="col-12">
      <div class="show-more-btn-wrapper mb-5">
        <button
          v-if="hasMoreOffers"
          class="btn text-center show-more-offers-btn"
          @click="emitGetMoreOffers"
        >
          <span class="text-caps font-bold"> {{translate('offDealsLoadMore')}}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import OfferCard from '@/components/offers/OfferCard'
import { media } from '@/infrastructure/Utils'

export default {
  name: 'OffersGrid',
  components: {
    OfferCard
  },
  emits: ['getMoreOffers'],
  props: {
    offers: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    hasMoreOffers: {
      type: Boolean,
      required: true
    },
    totalOffers: {
      type: Number,
      required: true
    },
    isMobile: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isCompactCardsView: false
    }
  },
  created() {
    window.addEventListener('resize', this.handleCardView)
  },
  mounted() {
    this.handleCardView()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleCardView)
  },
  methods: {
    emitGetMoreOffers() {
      this.$emit('getMoreOffers')
    },
    handleCardView() {
      const width = window.innerWidth
      this.isCompactCardsView = width <= media('tablet-l')
    }
  }
}
</script>

<style scoped lang="scss">
.cards-grid {
  display: grid;
  grid-auto-flow: row;
  grid-template-columns: repeat(4, 1fr);
  gap: 3rem;
  margin-bottom: 3rem;

  @media (max-width: media('laptop-m')) {
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }
  @media (max-width: media('tablet')) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
}

.offers-grid-header {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;

  @media (min-width: media('tablet-l')) {
    flex-direction: row;
    justify-content: space-between;
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }
}

.all-offers-title {
  font-size: 2.5rem;
  color: color('dark-grey');
  padding: 0 0.5rem;
}

.all-offers-counter {
  font-size: 1.5rem;
  color: color('dark-grey');
  padding: 0 0.5rem;
  margin: 0;
}

.show-more-btn-wrapper {
  display: flex;
  width: 100%;
  justify-content: center;

  .btn {
    border: 1px solid color('primary');
    padding: 1.7rem 2rem;
    color: color('primary');
  }
}

</style>
